import React from 'react';

import Chip from 'components/Chip';
import { colors } from 'theme/colors';
import { SchedulePauseReason } from 'utils/api/modules/schedules/schedules.types';

import { ScheduleStatusChipProps } from './types';

const PAUSE_REASON_TOOLTIP: Record<SchedulePauseReason, string | undefined> = {
  [SchedulePauseReason.MANUAL]: undefined,
  [SchedulePauseReason.NO_ACTIVE_ASSIGNEES]: 'No active assignees, assign someone to resume',
  [SchedulePauseReason.TEMPLATE_ARCHIVED]: 'Linked form template was archived',
};

const ScheduleStatusChip: React.FunctionComponent<ScheduleStatusChipProps> = ({ isPaused, pauseReason }) => {
  if (!isPaused) {
    return (
      <Chip
        id="schedule-status-active"
        label="Active"
        size="small"
        colors={{
          background: colors.ui.status.completed,
          foreground: colors.common.black,
        }}
      />
    );
  }

  return (
    <Chip
      id="schedule-status-paused"
      label="Paused"
      size="small"
      colors={{
        background: colors.grey[300],
        foreground: colors.common.black,
      }}
      tooltipTitle={pauseReason ? PAUSE_REASON_TOOLTIP[pauseReason] : undefined}
    />
  );
};

export default ScheduleStatusChip;
